@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="textArea"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="textArea"></ng-container>
}

<ng-template #textArea>
  <div class="container">
    @if (!hideIconSpace) {
      <mat-icon [ngClass]="{ focus: input.focused }">{{ icon }}</mat-icon>
    }
    <mat-form-field [appearance]="isOutline ? 'outline' : ''" color="accent">
      <mat-label>{{ shouldCapitalizeLabel ? (label | titlecase) : label }}</mat-label>
      <textarea
        matInput
        #input="matInput"
        [formControl]="control"
        [attr.aria-label]="ariaLabel || null"
        [rows]="rows || 1"
        [cdkTextareaAutosize]="shouldAutoResize">
      </textarea>
      <mat-hint [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
      @if (control.errors?.msError) {
        <mat-error>{{ control.errors?.msError == msErrorKey ? customMsError : control.errors?.msError }}</mat-error>
      }
      @if (control.errors?.required) {
        <mat-error>{{ 'required' | capitalizefirst }}</mat-error>
      }
    </mat-form-field>
    @if (info) {
      <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
      <button
        type="button"
        class="button-reset info-button"
        [attr.aria-label]="sysText.moreInformation_ariaLabel"
        [matTooltip]="info"
        [matTooltipShowDelay]="500"
        matTooltipPosition="above">
        <mat-icon class="button-icon">info_outline</mat-icon>
      </button>
    }
  </div>
</ng-template>
